import React from 'react';
import { CPVFOrderConfirmation, CPVFOrder, SuggestBoxWrapper, VFStatementText } from './layout/WrapperDiv';
import { infoWidth } from './components/constants';
import en from '../translationDefaults/en';
export const CheckCPFOrder = ({
  VFOrderData
}) => {
  const VFList = Object.values(VFOrderData);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VFStatementText, {
    id: "verify-cpf-order"
  }, /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
    width: infoWidth
  }, en.verifyFreqOrder), VFList.length > 0 && /*#__PURE__*/React.createElement(CPVFOrderConfirmation, null, VFList.map(plan => /*#__PURE__*/React.createElement(CPVFOrder, null, plan.frequencyMessage))) || `No changes made to frequencies. Please select 'Modify details' to update or select 'Modify order' to discard.`));
};
export default CheckCPFOrder;